import styled from "styled-components";

export const Container = styled.div`
  text-align: left;
  margin: 20px;
  font-size: 5em;
  max-width: 50%;
  display: flex;
  align-items: center;
`;

export const ProgressbarContainer = styled.div`
  max-width: 10%;
  max-height: 10%;
  margin: 20px;
`;
